module.exports = __webpack_public_path__ + "img/22.6797d7cb.webp";